import { destinationIsValidForSource } from "../destinations/validation";
import { EventType, libraryForEventType } from "../eventTypes";
import { LoadedDestinationInfo } from "../types/global";
import { DestinationDefinition, slugForDestination } from "./destinations";
import { DestinationSlug } from "./types";

export class DestinationMetadataManager {
  destinationMetadataMap: { [slug: string]: DestinationDefinition };

  constructor(destinationMetadataMap: {
    [slug: string]: DestinationDefinition;
  }) {
    this.destinationMetadataMap = destinationMetadataMap;
  }

  destinationSupportsTrack(slug: DestinationSlug) {
    const element = this.destinationMetadataMap[slug];

    return element && element.supportsTrack;
  }

  destinationSupportsBackfill(slug: DestinationSlug) {
    const element = this.destinationMetadataMap[slug];

    return element && element.supportsBackfill;
  }

  destinationSupportsServerSide(slug: DestinationSlug) {
    const element = this.destinationMetadataMap[slug];

    return element && element.supportsServerSide;
  }

  destinationIsWarehouse(slug: DestinationSlug) {
    const element = this.destinationMetadataMap[slug];

    return element && element.type === "warehouse";
  }

  destinationSupportsCohorts(slug: DestinationSlug) {
    const element = this.destinationMetadataMap[slug];

    return element && element.supportsCohorts;
  }

  destinationIsServerSide(slug: DestinationSlug) {
    return (
      this.destinationSupportsServerSide(slug) ||
      this.destinationIsWarehouse(slug)
    );
  }

  // Can we send the given event to the given destination? This makes sure that
  // the destination has been completely configured and that if we are sending the
  // event server side, the destination is configured for server side.
  destinationIsValidForEvent(
    loadedDest: LoadedDestinationInfo,
    eventType?: EventType | null
  ) {
    const eventIsServerSide = libraryForEventType(eventType) !== "web";
    const slug = slugForDestination(loadedDest);

    if (!this.destinationSupportsTrack(slug)) {
      return false;
    }

    if (eventIsServerSide && !this.destinationIsServerSide(slug)) {
      return false;
    }

    return destinationIsValidForSource(
      loadedDest,
      eventIsServerSide ? "server" : "client"
    );
  }
}
